<template>
  <label class="default-input" :class="class_list">
    <span
      :title="label"
      v-if="label"
      class="default-input__label">
      {{ label }}
      <span
        v-if="required"
        class="default-input__label-required">*</span>
      <span
        v-if="!is_valid"
        class="default-input__label-error">
        ({{ error_text }})
      </span>
    </span>
    <span class="default-input__block">
      <input
        class="default-input__item"
        :placeholder="placeholder"
        :value="get_value"
        :disabled="disabled"
        :readonly="read_only"
        :name="name"
        :required="required"
        v-bind="input_props"
        ref="input"
        @change="$emit('change', $event)"
        @click="$emit('click', $event)"
        @enter="$emit('enter', $event)"
        @mouseleave="$emit('mouseleave', $event)"
        @key_down="$emit('key_down', $event)"
        @key_up="$emit('key_up', $event)"
        :type="get_type"/>
      <span v-if="type_password"
            @click="show_password_text = !show_password_text"
            class="default-input__item-password">
            <eye-icon :slashed="show_password_text"/>
        </span>
      <span v-else-if="dropdown_icon"
            class="default-input__item-password">
          <eye-icon/>
      </span>
    </span>
  </label>
</template>

<script>

import EyeIcon from "../icons/EyeIcon";
import {phoneMask} from "../../helpers/global_vars";

export default {
  name: "DefaultInput",
  components: {EyeIcon},
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropdown_icon: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    read_only: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error_text: {
      type: String,
      default: 'This field is required'
    },
    input_props: {
      type: Object,
      default: null
    },
    validate_f: {
      type: Function,
      default: function (val) {
        let valid = false
        if (!isNaN(parseInt(val)) || (!!(val && val.length > 0))) {
          valid = true
        }
        return {
          valid: valid,
          error_text: !valid ? this.error_text : ''
        }
      }
    },
  },
  computed: {
    is_valid() {
        return this.valid
    },
    get_value() {
      if (!this.type_phone) {
        return this.value
      }
      return phoneMask(this.value)
    },
    type_phone() {
      return this.type === 'phone'
    },
    type_password() {
      return this.type === 'password'
    },
    get_type() {
      if (!this.type_password) return this.type
      return this.show_password_text ? 'text' : 'password'
    },
    class_list() {
      return {
        disabled: this.disabled,
        validate_inputs: this.required,
        error: !this.is_valid,
      }
    },
  },
  data() {
    return {
      show_password_text: false,
      valid: true
    }
  },
  mounted() {
    this.$refs.input.addEventListener('input', this.inputEvent)
  },
  methods: {
    inputEvent(event) {
      if (this.disabled) return
      if (this.type_phone) {
        let value = phoneMask(event.target.value)
        event.target.value = value
        return this.$emit('input', value)
      }
      return this.$emit('input', event.target.value)
    },
    updateValid(value) {
      if (!this.required) return
      const validation = this.validate_f(value, this.label, this.compare)
      this.valid = validation.valid
    },
  }
}
</script>
